import { NgModule } from '@angular/core';
import { BmsjHipsterSharedModule } from '../../shared';
import { RouterModule } from '@angular/router';
import { PROGRAM_ROUTES } from './program.route';
import { ProgramComponent } from './program.component';
import { MyStudiesComponent } from './my-studies.component';
import { MyListsComponent } from './my-lists.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { MyStudiesService } from './my-studies.service';
import { MyListsService } from './my-lists.service';
import { ProgramContext } from './program.context';
import { TruncateSpanComponent } from '../../shared/util/span-truncate/truncate-span.component';

@NgModule({
    imports: [
        BmsjHipsterSharedModule,
        RouterModule.forChild([...PROGRAM_ROUTES]),
        NgxChartsModule,
        TruncateSpanComponent
    ],
    declarations: [
        ProgramComponent,
        MyStudiesComponent,
        MyListsComponent
    ],
    providers: [
        MyStudiesService,
        MyListsService,
        ProgramContext
    ]
})
export class ProgramModule {
}
